import { render, staticRenderFns } from "./TaskDetails.vue?vue&type=template&id=b625605e&scoped=true&"
import script from "./TaskDetails.vue?vue&type=script&lang=ts&"
export * from "./TaskDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDetails.vue?vue&type=style&index=0&id=b625605e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b625605e",
  null
  
)

export default component.exports